module.exports = __webpack_public_path__ + "static/media/sidebar.ebfdda6d.png";